<div class="create-edit-instructions">
  <sdps-modal-beta
    [hidden]="!isModalOpen"
    id="create-new-modal"
    [sdpsTitle]="modelHeading"
    size="flex--large"
    back-drop-close-disabled="true"
    (close)="afterCloseInstructionModal($event, viewMode)"
    class="mf-aip-sch-modal"
    sch-modal-renderer>
    <div slot="modal-body">
      @if (viewMode === 'SUBMITTED') {
        <div class="printButton">
          <a class="print-link" (click)="printButtonClick()">
            <em class="print-icon"></em>
            <span>Print</span>
          </a>
        </div>
      }
      <form [formGroup]="instructionsForm" (ngSubmit)="previewInstruction()" id="mipInstructionsForm">
        <instruction-notification></instruction-notification>
        <div [hidden]="viewMode != 'CREATE' && viewMode != 'EDIT'">
          <div class="sdps-grid-container sdps-wrap create-edit-instructions" id="create-edit-instructions-container">
            <div class="col-12 account-container">
              <div class="sdps-grid-container col-12 account-sub-section">
                <div class="col-5" style="padding-left: 0px; padding-right: 0px">
                  <div class="sdps-form-element" [ngClass]="accountHasError ? 'sdps-has-error' : ''">
                    <label class="sdps-form-element__label">
                      Account
                      <span class="sdps-form-element__label-help" style="color: #5a6772" aria-hidden="true"
                        >search by name, number, or description</span
                        >
                      </label>
                      <div>
                        <account-search
                          [selectedValue]="selectedAccountWithName"
                          (selected)="accountSelected($event)"
                          (validAccount)="showHideInvalidAccountMessage($event)"
                          (blankAccountField)="showHideAccountRequired()"
                          [viewMode]="viewMode">
                        </account-search>
                      </div>
                      @if (accountHasError) {
                        <div
                          class="error-message account-error sdps-form-element__error"
                        [innerText]="accountErrorMessage"></div>
                      }
                    </div>
                  </div>
                  <div
                    class="col"
                    [ngClass]="selectedAccountWithName ? 'account-details-selected-section' : 'account-details-section'">
                    @if (selectedAccountWithName?.length > 0) {
                      <div>
                        <div [innerText]="selectedAccount" class="account-details-text" style="padding-top: 10px"></div>
                        <div style="padding-top: 28px; padding-bottom: 15px">
                          <div [innerText]="selectedAccountName" class="account-details-text"></div>
                          <div [innerText]="selectedAccountDescription" class="account-details-text"></div>
                          <div [innerText]="selectedAccountType" class="account-details-type"></div>
                        </div>
                      </div>
                    }
                  </div>
                </div>
              </div>

              <div class="col-12 symbol-container" style="padding-right: 0px; padding-left: 12px">
                <div class="sdps-grid-container col-12 symbol-sub-section" style="margin: 0">
                  <div class="col-5" style="padding-left: 0px; padding-right: 0px">
                    <div id="symbol-container" class="sdps-form-element">
                      <label class="sdps-form-element__label">
                        Mutual Fund
                        <common-tooltip-with-icon-image [tooltip]="mutualFundTooltipText"></common-tooltip-with-icon-image>
                      </label>
                      <symbol-search
                        [selectedAccount]="selectedAccount"
                        [selectedValue]="securityName"
                        (selected)="symbolSelected($event)"
                        (inavalidFund)="invalidFundSelected()"
                        (noAvailableFunds)="showSymbolValidation($event)"
                        (blankSymbolField)="checkIfSymbolIsBlank($event)"
                        [viewMode]="viewMode">
                      </symbol-search>
                      @if (symbolHasError) {
                        <div
                          class="error-message symbol-error sdps-form-element__error"
                        [innerText]="symbolErrorMessage"></div>
                      }
                    </div>
                  </div>
                  <div class="col" [ngClass]="selectedSymbol ? 'symbol-details-selected-section' : 'symbol-details-section'">
                    @if (selectedSymbol?.length > 0) {
                      <div>
                        <div [innerText]="selectedSymbol" class="symbol-text" style="padding-top: 10px"></div>
                        <div [innerText]="selectedSymbolName" class="symbol-detail-text"></div>
                      </div>
                    }
                  </div>
                </div>
              </div>

              <div class="sdps-grid-container col-12 transaction-details-container">
                <div class="sdps-grid-container col-4 transaction-sub-container">
                  <div class="dropdown col-6">
                    <label class="sdps-form-element__label">Transaction type</label>
                    <select
                      id="transaction-type-select-id"
                      class="form-control form-control-sm"
                      name="transactionType"
                      (change)="updateTransactionType($event)">
                      @if (!instructionsData?.transactionType) {
                        <option value="empty" disabled selected hidden></option>
                      }
                      <option value="Buy">Buy</option>
                      <option value="Sell">Sell</option>
                    </select>

                    <div class="dropdown">
                      <label class="sdps-form-element__label">Amount type</label>
                      <select
                        class="form-control form-control-sm"
                        name="amountType"
                        formControlName="amountType"
                        (change)="updateAmountType($event)">
                        @if (!instructionsData?.amountType) {
                          <option disabled selected hidden></option>
                        }
                        <option [value]="'Dollars'">Dollars ($)</option>
                        <option [value]="'Shares'">Shares</option>
                      </select>
                    </div>
                  </div>

                  <div class="col-6 discretionary-solicited-column">
                    <sdps-checkbox
                      checked
                      label="Discretionary"
                      (change)="discretionaryChanged($event)"
                    sdps-id="sdps-discretionary"></sdps-checkbox>
                    <sdps-checkbox
                      label="Solicited"
                      (change)="solicitedChanged($event)"
                    sdps-id="sdps-solicited"></sdps-checkbox>
                    <div
                      class="sdps-form-element amount-container"
                      style="margin: 2px"
                      [ngClass]="isAmountBlank() ? 'sdps-has-error' : ''">
                      <label class="sdps-form-element__label">Amount</label>
                      <input
                        class="sdps-input"
                        type="text"
                        name="amount"
                        (amountPasted)="validateAmountField(instructionsForm.get('amountType').value)"
                        (input)="amountChanged()"
                        (blur)="formatAmount()"
                        formControlName="amount"
                        [value]="displayAmount" />
                        @if (isAmountBlank()) {
                          <div class="error-message amount-error sdps-form-element__error">
                            You must enter an amount to continue
                          </div>
                        }
                      </div>
                    </div>
                  </div>

                  <div class="sdps-grid-container col-5 transaction-sub-container" style="margin-right: 8px; margin-left: 8px">
                    <div class="dropdown col-5">
                      <label class="sdps-form-element__label">Frequency</label>
                      <select
                        class="form-control form-control-sm frequency-container"
                        formControlName="frequency"
                        (change)="updateFrequency($event)">
                        @for (frequency of frequencySource; track frequency) {
                          <option
                            [value]="frequency.value"
                          [innerText]="frequency.label"></option>
                        }
                      </select>
                    </div>

                    <div class="sdps-datepicker col-7 start-date" [ngClass]="startDateHasError ? 'sdps-has-error' : ''">
                      <label class="sdps-form-element__label">
                        <span class="sdps-form-element__label start-date-label" [innerText]="startDateLabel"></span>
                        <span class="sdps-sr-only">Type date using the format</span>
                        <span class="sdps-form-element__label-help" aria-hidden="true">(mm/dd/yyyy)</span>
                        <span class="sdps-sr-only">m m / d d / y y y y</span>
                      </label>

                      <div class="calendar-datepicker-container">
                        <input matInput
                          id="calendar-startDate"
                          class="sdps-input"
                          formControlName="startDate"
                          aria-label="Start Date"
                          [min]="startAtDate"
                          [matDatepicker]="startDatePicker"
                          (dateChange)="checkStartDateBasedOnFrequency()"
                          (blur)="checkStartDateBasedOnFrequency()">
                          <mat-datepicker-toggle
                            id="calendarIcon-startDate"
                            [disabled]="isStartDateButtonDisabled"
                            [disableRipple]="true"
                            matIconSuffix
                          [for]="startDatePicker"></mat-datepicker-toggle>
                          <mat-datepicker #startDatePicker></mat-datepicker>
                        </div>
                        @if (startDateErrorMessage) {
                          <div
                            class="error-message start-date-error"
                            [ngClass]="startDateHasError ? 'sdps-form-element__error' : ''"
                          [innerText]="startDateErrorMessage"></div>
                        }
                      </div>

                      <div class="days-to-execute-container">
                        <label class="sdps-form-element__label"
                          >Execute transaction on:
                          <common-tooltip-with-icon-image [tooltip]="frequencyTooltipText"></common-tooltip-with-icon-image>
                        </label>
                        @if (
                          instructionsForm.get('frequency').value === frequencySource[0].value ||
                          instructionsForm.get('frequency').value === frequencySource[1].value
                          ) {
                          <div
                            >
                            <select
                              class="weekday-execute dropwdown form-control form-control-sm"
                              name="dayToExecute"
                              formControlName="dayToExecute"
                              (change)="dayToExecuteChanged($event)">
                              <option value="Monday">Monday</option>
                              <option value="Tuesday">Tuesday</option>
                              <option value="Wednesday">Wednesday</option>
                              <option value="Thursday">Thursday</option>
                              <option value="Friday">Friday</option>
                            </select>
                          </div>
                        }

                        @if (instructionsForm.get('frequency').value === frequencySource[2].value) {
                          <div
                            class="sdps-form-element__label"
                            >
                            the
                            <select
                              class="days-to-execute-dropdown dropwdown form-control form-control-sm"
                              name="dayToExecute"
                              formControlName="dayToExecute"
                              id="day-one"
                              (change)="updateSecondDayToExecute()">
                              @for (days of daysSource; track days) {
                                <option [value]="days" [innerText]="days"></option>
                              }
                            </select>
                            and
                            <select
                              class="days-to-execute-dropdown dropwdown form-control form-control-sm"
                              name="dayToExecute2"
                              formControlName="dayToExecute2"
                              id="day-two"
                              (change)="dayToExecuteChanged($event)">
                              @for (days of daysSource; track days) {
                                <option [value]="days" [innerText]="days"></option>
                              }
                            </select>
                            of the month
                          </div>
                        }

                        @if (
                          instructionsForm.get('frequency').value === frequencySource[3].value ||
                          instructionsForm.get('frequency').value === frequencySource[4].value ||
                          instructionsForm.get('frequency').value === frequencySource[5].value ||
                          instructionsForm.get('frequency').value === frequencySource[6].value
                          ) {
                          <div
                            class="sdps-form-element__label"
                            >
                            Day
                            <select
                              class="days-to-execute-dropdown dropwdown form-control form-control-sm"
                              name="dayToExecute"
                              formControlName="dayToExecute"
                              (change)="dayToExecuteChanged($event)">
                              @for (days of daysSource; track days) {
                                <option [value]="days" [innerText]="days"></option>
                              }
                            </select>
                            of the month
                          </div>
                        }
                        @if (dayToExecuteErrorMessage) {
                          <div
                            class="error-message day-to-execute-error"
                            [ngClass]="dayToExecuteHasError ? 'sdps-form-element__error' : ''"
                          [innerText]="dayToExecuteErrorMessage"></div>
                        }
                      </div>
                    </div>

                    <div class="sdps-grid-container col-3 transaction-sub-container">
                      <sdps-radio-group class="duration-radio-container" (sdpsChange)="updateDuration($event)">
                        <label class="sdps-form-element__label" [ngClass]="endDateHasError ? 'duration-error' : ''"
                          >Duration</label
                          >
                          <sdps-radio
                            class="duration-radio-button"
                            value="Run until stopped"
                            sdps-id="run-until-stopped"
                            label="Run until stopped"
                          [checked]="isDurationRunUntilStopped"></sdps-radio>
                          <sdps-radio
                            class="duration-radio-button"
                            value="Stop on selected date"
                            sdps-id="stop-date"
                            [label]="stopDateLabel"
                          [checked]="isDurationStopOnSelectedDate"></sdps-radio>
                        </sdps-radio-group>
                        @if (showEndDate) {
                          <div
                            class="sdps-datepicker stop-date"
                            [ngClass]="endDateHasError ? 'sdps-has-error' : ''"
                            >
                            <div class="calendar-datepicker-container">
                              <input matInput
                                id="calendar-endDate"
                                class="sdps-input"
                                formControlName="endDate"
                                aria-label="Stop Date"
                                [min]="endDateMin"
                                [matDatepicker]="endDatePicker"
                                (dateChange)="checkEndDateForErrors()"
                                (blur)="checkEndDateForErrors()">
                                <mat-datepicker-toggle
                                  id="calendarIcon-endDate"
                                  [disabled]="isEndDateButtonDisabled"
                                  [disableRipple]="true"
                                  matIconSuffix
                                [for]="endDatePicker"></mat-datepicker-toggle>
                                <mat-datepicker #endDatePicker></mat-datepicker>
                              </div>
                              @if (endDateErrorMessage) {
                                <div
                                  class="error-message end-date-error"
                                  [ngClass]="endDateHasError ? 'sdps-form-element__error' : ''"
                                [innerText]="endDateErrorMessage"></div>
                              }
                            </div>
                          }
                        </div>
                      </div>
                    </div>
                  </div>
                  @if (viewMode === 'PREVIEW' || viewMode === 'VIEW' || viewMode === 'SUBMITTED') {
                    <div>
                      <preview-instructions
                        [previewData]="instructionsData"
                        [viewMode]="viewMode"
                        [showError]="isError"
                        [transactionFee]="transactionFee">
                      </preview-instructions>
                    </div>
                  }
                </form>
              </div>

              <div slot="modal-footer" style="display: flex; flex-direction: row">
                @if (viewMode === 'CREATE' || viewMode === 'EDIT') {
                  <div class="link-section">
                    <a href="" class="create-instructions-links" (click)="closeModal($event, viewMode)">Cancel</a>
                    <button
                      type="button"
                      [disabled]="!checkIfFormIsValid()"
                      class="btn btn-success"
                      [ngClass]="!checkIfFormIsValid() ? 'create-instructions-disabled-btn' : 'create-instructions-enabled-btn'"
                      (click)="previewInstruction()">
                      Preview
                    </button>
                  </div>
                }
                @if (viewMode === 'PREVIEW') {
                  <div class="link-section">
                    <a href="" class="create-instructions-links" (click)="goBack($event)">Back</a>
                    <button
                      type="button"
                      [disabled]="isEmployeeAccount()"
                      class="btn btn-success"
                      [ngClass]="isEmployeeAccount() ? 'create-instructions-disabled-btn' : 'create-instructions-enabled-btn'"
                      (click)="submitInstruction()">
                      Submit
                    </button>
                  </div>
                }
                @if (viewMode === 'SUBMITTED') {
                  <div class="link-section buttonFlexPosition">
                    <button type="button" class="btn create-another-button" (click)="createAnotherInstruction()">
                      Create another instruction
                    </button>
                  </div>
                }
                @if (viewMode === 'VIEW' || viewMode === 'SUBMITTED') {
                  <div class="link-section">
                    <button type="button" class="btn btn-success create-instructions-enabled-btn" (click)="closeModal($event, viewMode)">
                      Close
                    </button>
                  </div>
                }
              </div>
            </sdps-modal-beta>
          </div>
